import React, { useState } from "react";
import "./ManualPlanningPage.css";
import Timeline from "./components/Timeline/Timeline-2";
import Editor from "./components/Editor/Editor";
import Header from "./components/Header/Header";
import { TimelineProvider } from "./context/TimelineProvider";

function ManualPlanningPage({ enterpriseId, divisionId }) {
  return (
    <TimelineProvider divisionId={divisionId}>
      <div className="mt-4 page">
        <Header enterpriseId={enterpriseId} divisionId={divisionId} />

        <div className="d-flex justify-content-between">
          <Timeline divisionId={divisionId} />
          <Editor divisionId={divisionId} />
        </div>
      </div>
    </TimelineProvider>
  );
}

export default ManualPlanningPage;
